module.exports = "/static/media/drop_icon.6846552b.svg";